<template>
  <!-- 主编单位 -->
  <div class="form-container">
    <div class="form-title margin-b20">主编单位</div>
    <div class="table-wrapper">
      <div class="table-header-wrapper">
        <div class="table-header">
          <div class="table-header-item one">主编单位</div>
        </div>
      </div>
      <div class="table-body-wrapper">
        <div class="table-body">
          <div class="table-body-item">
            <div
              class="one"
              v-for="(item, index) in draftCompanyList"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    draftCompanyList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.table-header {
  height: 40px;
  display: flex;
  background: #f5f5f5;
  border: 1px solid #dcdcdc;
  .table-header-item {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 12px;
    font-weight: 500;
    border-right: 1px solid #dcdcdc;
    white-space: nowrap;
    &:last-child {
      border-right: none;
    }
  }
  .one {
    flex: 1;
  }
  .two {
    flex: 3;
  }
}
.table-body-wrapper {
  border: 1px solid #dcdcdc;
  border-top: none;
  .table-body {
    .table-body-item {
      min-height: 50px;
      display: flex;
      color: #333;
      font-size: 12px;
      font-weight: 500;
      border-top: 1px solid #dcdcdc;
      &:first-child {
        border-top: none;
      }
      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #dcdcdc;
        &:last-child {
          border-right: none;
        }
      }
      .one {
        flex: 1;
      }
      .two {
        flex: 3;
      }
    }
  }
}
</style>
